import { axios } from '@/plugins/axios-pol'

const basePath = '/personal/api/EstadoFuerza'

export default class AsistenciaApiRepository {
  async getAsistenciaByPersonal(idPersonal) {
    const { data } = await axios.get(`${basePath}/personal/${idPersonal}/asistencia`)
    return data.data
  }

  async getAsistenciaBySubsede(idSubSede, fechaIni, fechaFin) {
    const { data } = await axios.get(
      `${basePath}/asistencia/subsede/${idSubSede}/fechaIni/${fechaIni}/fechaFin/${fechaFin}`
    )
    return data.data
  }

  async getAsistenciaByIdAsistencia(idPersonal, idAsistencia) {
    const { data } = await axios.get(`${basePath}/personal/${idPersonal}/asistencia/${idAsistencia}`)
    return data.data
  }

  async create({ idPersonal, ...payload }) {
    const { data } = await axios.post(`${basePath}/personal/${idPersonal}/asistencia`, payload)
    return data.data
  }

  async patchAsistencia(idPersonal, idAsistencia, payload) {
    const { data } = await axios.put(`${basePath}/personal/${idPersonal}/salida/asistencia/${idAsistencia}`, payload)
    return data.data
  }

  async updateAsistencia(idPersonal, idAsistencia, payload) {
    const { data } = await axios.put(`${basePath}/personal/${idPersonal}/asistencia/${idAsistencia}`, payload)
    return data.data
  }

  async getTipoAsistencia() {
    const { data } = await axios.get(`${basePath}/tipoAsistencia`)
    return data.data
  }

  async getAllTipoServicio() {
    const { data } = await axios.get(`${basePath}/tipoServicio`)
    return data.data
  }

  async getTipoServicioByType(id) {
    const { data } = await axios.get(`${basePath}/tipoServicio/${id}`)
    return data.data
  }
}
